const container = {
  flex: 4,
  display: 'flex',
  flexDirection: 'column',
}

const listWrapper = {
  overflow: 'auto',
  height: '99%',
}

const renderDetailsContainer = {
  px: '16px',
  gap: '3px',
}

const countryRenderBox = {
  flexDirection: 'row',
  gap: '5px',
  alignItems: 'center',
}

const countryIconContainer = {
  width: '20px',
  display: 'flex',
}

const countryLabel = {
  fontWeight: '700',
  fontSize: '15px',
  textTransform: 'uppercase',
}

const recalculateBtn = {
  height: 27,
  width: 27,
}

const calculatedBtn = {
  height: 23,
  width: 23,
  color: 'gray',
}

const circularProgressIcon = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
}

export {
  container,
  listWrapper,
  renderDetailsContainer,
  countryRenderBox,
  countryIconContainer,
  countryLabel,
  recalculateBtn,
  calculatedBtn,
  circularProgressIcon,
}
